import { useApi, createApiHook } from "../utils/apiUtils";

const useCreateSurveyResponse = () => {
  const { apiPatch } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const createSurveyResponse = async ({ id, assignapp_id, assignapp_questionnaire_id, content, status, last_page_name = null }) => {
    startLoading();

    const response = await apiPatch(
      `/surveys/${id}/responses/upsert_response_and_update_questionnaire_status`,
      "Error al crear la respuesta del cuestionario",
      {
        content,
        assignapp_id,
        assignapp_questionnaire_id,
        status,
        last_page_name,
      },
    );

    setResponse(response);
    return response;
  };

  return { createSurveyResponse, data, loading, error };
};

export default useCreateSurveyResponse;
